import { LOGIN_F, LOGIN_S, LS_AUTHTOKEN, LS_USER } from "../constants";
import { v4 as uuidv4 } from 'uuid';

//To concate the path for the public folder
export const toAbsoluteUrl = (pathname) => process.env.PUBLIC_URL + pathname;

// Fun used for setting up the common header for axios through out the app and rehydrate the redux store
export const setupAxios = (axios, store) => {


  // It's used to rehydrate redux auth data when page is refreshed


  if (localStorage.getItem(LS_AUTHTOKEN) && localStorage.getItem(LS_USER)) {

    const token = (localStorage.getItem(LS_AUTHTOKEN));
    const userData = JSON.parse(localStorage.getItem(LS_USER));

    if (token) {
      store.dispatch({ type: LOGIN_S, payload: { data: userData } });
    } else {
      store.dispatch({ type: LOGIN_F, payload: {} });
    }
  }


  // It's used to intercept all the axios api response
  axios.interceptors.response.use(null, (err) => {
    if (err.response) {
      if (err.response.status === 403) {
        store.dispatch({ type: LOGIN_F });
        return Promise.reject(err);
      } else {
        return Promise.reject(err);
      }
    } else if (err.request) {
      return Promise.reject({
        response: {
          data: {
            message: "Something went wrong, Please try again later!!!",
          },
        },
      });
    }
  });
};

// Encrypt Function
export const encrypt = (param) => {
  if (param) return btoa(param);
  else return "";
};

// Decrypt Function
export const decrypt = (param) => {
  if (param) return atob(param);
  else return "";
};

// Debouncing for input search 
export const debounce = (func) => {
  let timer;
  return function (...args) {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(context, args);
    }, 1000);
  };
};



export function createElementFromHTML(htmlString) {
  var div = document.createElement("div");
  div.innerHTML = htmlString.trim();

  return div.firstChild;
}

export function updateDomStyle(
  node,
  style
) {
  Object.keys(style).forEach((styleKey) => {
    if (style && style[styleKey]) {
      node.style.setProperty(styleKey, style[styleKey]);
    }
  });
}

export const generateUUID = () => {
  return uuidv4();
};

// antd Upload's default previewFile draws a 200x200 canvas thumbnail, which looks
// pixelated in large preview areas. Use this to preview the original file instead.
// Returns a blob: URL (not a data: URL) so the preview link can also be opened in a new tab.
export const previewFullImage = (file) => Promise.resolve(URL.createObjectURL(file));
